import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import "./building-create-section.component.scoped.sass";
import Incrementer from "../incrementer/incrementer.component";
import Button from "@material-ui/core/Button/Button";
import { icons } from "src/statics/icons";
import { ShopContext } from "src/store/providers/shop.provider";
import { currency, tagPrice } from "src/statics/shop";
import { BuildingsService } from "src/services/buildings/buildings.service";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import BuildingCreateNextStep from "../building-create-next-step/building-create-next-step.component";
import { TextField, Grid, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { PaymentService } from "src/services/payment/payment.service";
export default function BuildingCreateSectionComponent() {
  const [t] = useTranslation();
  const { createBuildingsIco, infoIco } = icons;
  const buildingsService = new BuildingsService();
  const paymentService = new PaymentService();
  const [success, setSuccess]: any = useState(null);
  const [loading, setLoading]: any = useState(false);
  const [error, setError]: any = useState(null);
  const { buildings, inputChange, buildingsCountChange, hasError } = useContext(
    ShopContext
  );

  const back = () => {
    setSuccess(null);
    setError(null);
  }

  const createBuildings = async(): Promise<void> => {
    try {
      setLoading(true);
      await buildingsService.createMany(buildings);
      await paymentService.subscribeCustomer(buildings);
      storeBuildings();
      setSuccess('create_success');
      setError(null);
    } catch (error) {
      setError('create_error');
      setSuccess(null);
    } finally {
      setLoading(false);
    }
  };

  const storeBuildings = () => {
    localStorage.setItem('buildings', JSON.stringify(buildings));
  }

  const actionFunction = (type: string) => {
    return buildingsCountChange(type);
  };

  const inputChangeHandler = (event: any, index: number, prop: string) => {
    const value = event?.target?.value;
    return inputChange(index, prop, value);
  };

  const formatPrice = (price: number): string => {
    return `${price}.00`;
  }

  return (
    <div className="create-section">
      {!(error || success) && <div className="creator">
      <div className="info">
        <div className="clean-tag">
          CleanTag
        </div>
        <div className="price">
          {currency.char} {formatPrice(buildings.length * tagPrice || tagPrice)}
        </div>
      </div>
      <div className="description">
       {t('create_building_description')} <br /> {t('create_building_description_2')}
      </div>
      <div className="quantity">
        <Incrementer actionFunction={actionFunction} count={buildings.length || 0} />
        <div className="tag-price"> {t('tag_price_text')}</div>
      </div>
      <div className="buildings">
        {buildings.map((building: any, index: number) => (
          <div key={`b${index}`} className="one-building">
            <div className="title">
              CleanTag {index + 1}
            </div>
            <TextField name="tagName" type="text" className="shop-input" label={t("tag_name")} 
                onChange={(event: any) => inputChangeHandler(event, index, 'name')}/>
            <Grid container direction="row" justify="space-between">
              <Grid item xs={3} sm={3}> 
                <FormControl style={{width: "calc(100% - 10px)"}} className="shop-input country-filter">
                  <InputLabel id="country">{t("country")}</InputLabel>
                  <Select
                    labelId="country"
                    id="country-select"
                    onChange={(event: any) => inputChangeHandler(event, index, 'country')}
                  >
                    <MenuItem value={'Austria'}>Austria</MenuItem>
                    <MenuItem value={'Egypt'}>Egypt</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4} sm={4}> 
                <TextField name="postalCode" type="number" className="shop-input" style={{width: "calc(100% - 30px)"}} label={t("postalCode")} 
                onChange={(event: any) => inputChangeHandler(event, index, 'postalCode')}/>
              </Grid>
              <Grid item xs={5} sm={5}> 
                <TextField name="city" type="text" className="shop-input" style={{width: "calc(100% - 18px)"}} label={t("city")} 
                onChange={(event: any) => inputChangeHandler(event, index, 'city')}/>
              </Grid>
            </Grid>
            <TextField name="address" type="text" className="shop-input" label={t("address")} 
            onChange={(event: any) => inputChangeHandler(event, index, 'address')}/>
          </div>
        ))}
      </div>
      <Button
        variant="contained"
        disabled={loading || hasError}
        className="btn-tool btn-warning"
        onClick={createBuildings}
      >
        {!loading && <div className="btn-flex"><img
          alt="icon"
          className="icon icon-refresh"
          src={createBuildingsIco}
        />{t("order")}</div>}
        {loading && <CircularProgress color="primary" />}
      </Button>
      
      </div>}
      {(error || success) && <BuildingCreateNextStep back={back} message={ error ? error : success } type={error ? 'error' : 'success'} />}
      <div className="info-bottom">
        <img alt="info" src={infoIco} className="icon" height="13px" />
        <div className="text">
          {t('create_building_hint')}
        </div>
      </div>
    </div>
  );
}
